import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import cssClasses from "./RejectReason.module.css";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";
import TextField from "@mui/material/TextField";

import {
  getAllCp,
  updateStatus,
  insertCpLogs,
} from "../../Services/ChannelPartner";
import { errorTost, offlineToast } from "../../Services/Toast";
import { Network } from "@capacitor/network";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  TextFieldStyle: {
    width: "100%",
    background: "#F2F4F7 !important",
    paddingRight: "0rem !important",
    borderRadius: "10px !important",
    fontSize: "1.6rem !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "2.4rem !important",
  },
  inputStyle: {
    fontFamily: "Inter-Medium !important",
    paddingRight: "0rem !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7  !important",
    //   border: '1px solid #D0D5DD',
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    borderRadius: "10px !important",
    border: "1px solid #F2F4F7",
    "& input": {
      fontSize: "1.6rem !important",
      lineHeight: "2.4rem !important",
      color: "#101828 !important",
      padding: "1.3rem 1.4rem",
      border: "none !important",
      boxShadow: "none !important",
    },

    "& input[text]": {
      color: "#101828 !important",
    },
    "& input[input:-internal-autofill-selected]": {
      background: "#F2F4F7 !important",
    },
    "& input[value]": {
      background: "#FFFFF !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused": {
      background: "#FFFFFF !important",
      border: "1px solid #84CAFF !important",
      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
      boxShadow: "none !important",
    },
  },

  helperText: {
    background: "#FFFFFF !important",
    fontSize: "1.4rem !important",
    margin: "0rem 0 0 0 !important",
    fontFamily: "Inter-Medium !important",
    lineHeight: "1.8rem !important",
    paddingTop: "0.5rem !important ",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "0rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "3rem",
    lineHeight: "3.8rem",
    color: "#101828",
    marginBottom: "1.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
}));
export default function RejectReason({
  open,
  handleClose,
  saveResp,
  data,
  loggedInUserId,
}) {
  const classes = useStyles();
  const [reason, setReason] = useState("");
  const [helperText, setHelperText] = useState("");
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  function submit() {
    //Api Call
    if (reason === "") {
      setHelperText("Please Enter Reason");
    } else {
      //save
      Network.getStatus().then((status) => {
        if (status.connected) {
      updateStatus(data.id, "rejected", reason)
        .then((res) => {
          insertCpLogs(data.id, "rejected", loggedInUserId)
            .then((resp) => {
              console.log(resp);
              saveResp(true);
              close();
            })
            .catch((err) => {
              errorTost(err.message);
            });
        })
        .catch((err) => {
          errorTost(err.message);
        });
      }else{
        offlineToast();
      }});
    }
  }
  function close() {
    handleClose();
  }
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
      button
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={classes.wrapperIcons}>
          {/* {icon} */}
          <span className={classes.closeIcon} onClick={handleClose}>
            <Close width={"1.2rem"} height={"1.2rem"} />
          </span>
        </div>
        <div className={classes.title}>Reason</div>
        <div className={classes.subTitle} >
          <TextField
           maxRows={4}
            value={reason}
            onChange={(e) => {
              e.target.value = e.target.value.trimStart();
              if (e.target.value.length <= 200) {
                setReason(e.target.value);
              }
              if (e.target.value.length === 0) {
                setHelperText("Please enter reason to reject");
                setDisableSubmitButton(true);
              } else {
                setHelperText("");
                setDisableSubmitButton(false);
              }
            }}
            placeholder={"Type..."}
            helperText={helperText}
            error={helperText !== ""}
            className={classes.TextFieldStyle}
            InputProps={{
              className: classes.inputStyle,
            }}
            inputProps={{ min: 0 }}
            FormHelperTextProps={{ className: classes.helperText }}
            multiline
          />
        </div>
        <div className={classes.wrapperButtons}>
          <Button
            style={{
              color: "#344054",
              backgroundColor: "#ffffff",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
            }}
            btnName={"Cancel"}
            clicked={handleClose}
          />

          <Button
            style={{
              color: "#ffffff",
              backgroundColor: "#1570EF",
              fontSize: "1.6rem",
              lineHeight: "2.4rem",
            }}
            btnName={"Submit"}
            clicked={submit}
            disable={disableSubmitButton}
          />
        </div>
      </Box>
    </Modal>
  );
}
